import { GreetingProviderProps } from "../../types";
import { IApiGreeting, IApiGreetingsWithToggle } from "../types/greeting-interfaces";
import { GreetingProvider, LanguageProvider } from ".";

interface GreetingSettingsProvidersProps {
    children: React.ReactNode;
    characterId: string;
    greetingProps: Omit<GreetingProviderProps, "children" | "updateGreetings" | "isUpdatingKioskSetting">;
    getAvailableLanguageOptions?: (currentIndex: number) => { label: string; value: string }[];
    getUsedLanguagesByOthers?: (currentIndex: number) => string[];
    updateGreetings: (greetingsData: IApiGreeting[] | IApiGreetingsWithToggle) => Promise<void>;
    isUpdatingKioskSetting: boolean;
}

export const GreetingSettingsProviders = ({
    children,
    characterId,
    greetingProps,
    getAvailableLanguageOptions,
    getUsedLanguagesByOthers,
    updateGreetings,
    isUpdatingKioskSetting,
}: GreetingSettingsProvidersProps) => {
    return (
        <LanguageProvider
            characterId={characterId}
            getAvailableLanguageOptions={getAvailableLanguageOptions}
            getUsedLanguagesByOthers={getUsedLanguagesByOthers}
        >
            <GreetingProvider
                {...greetingProps}
                updateGreetings={updateGreetings}
                isUpdatingKioskSetting={isUpdatingKioskSetting}
            >
                {children}
            </GreetingProvider>
        </LanguageProvider>
    );
};
